import React from 'react'

const EventsCarouselComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default EventsCarouselComponent
